export type UpdateCallback = (percent: number) => void;

export abstract class Loader {
    protected _callback: Function;
    protected _updateCallback: UpdateCallback;
    protected _onErrorCallback: Function;
    protected _size: number;
    protected _loadedPercent = 0;
    protected _resourcesToLoadCount = 0;
    protected _loadedResourcesCount = 0;

    constructor(callback: Function, updateCallback: UpdateCallback, errorCallback: Function, size: number) {
        this._callback = callback;
        this._updateCallback = updateCallback;
        this._onErrorCallback = errorCallback;
        this._size = size;
    }

    public abstract load(): void;

    protected onError(e: any): void {
        this._onErrorCallback(e);
    }

    protected abstract onProgress(e: any): void;

    public get loadedSize(): number {
        return this._loadedPercent * this._size;
    }

    public get loadedPercent(): number {
        return this._loadedPercent;
    }

    public get size(): number {
        return this._size;
    }
}
